import React from "react";
import AppSidebar from "../AppSidebar";
import { faFolderOpen, faChartBar } from "@fortawesome/free-solid-svg-icons";

const NAV_ITEMS = [
  { href: "/bcm_norms/file-manager", label: "File Manager",  icon: faFolderOpen },
  { href: "/bcm_norms/analyze",      label: "Norms Tables",  icon: faChartBar },
];

export default function BcmNormsSide() {
  return <AppSidebar navItems={NAV_ITEMS} />;
}
